import { TypedDocumentNode, gql } from '@apollo/client';

import { Sport } from '__generated__/globalTypes';
import useQuery from 'hooks/graphql/useQuery';

import {
  NoCardRoute,
  NoCardRouteVariables,
} from './__generated__/useNoCardRoute.graphql';

const QUERY = gql`
  query NoCardRoute($sport: Sport!) {
    config {
      id
      so5 {
        id
        noCardRoute(sport: $sport) {
          id
          emailAddress
          nextOpenDate
          nextCloseDate
        }
      }
    }
  }
` as TypedDocumentNode<NoCardRoute, NoCardRouteVariables>;

interface Props {
  sport: Sport;
}

export default ({ sport }: Props) => {
  const { data, loading } = useQuery(QUERY, { variables: { sport } });

  return {
    noCardRoute: data?.config?.so5?.noCardRoute || {
      nextOpenDate: new Date(),
      nextCloseDate: new Date(),
      emailAddress: 'football-entry@sorare.com',
    },
    loading,
  };
};
